import { useCallback, useMemo } from 'react'

import { useReduxDispatch } from '@/store/hooks'
import { modalActions, type ModalType } from '@/store/modal'

export const useModal = (id: string) => {
  const dispatch = useReduxDispatch()

  const close = useCallback(() => {
    dispatch(modalActions.close(id))
  }, [dispatch, id])

  const open = useCallback(
    (modal: Omit<ModalType, 'id'>) => {
      dispatch(modalActions.open({ ...modal, id }))
    },
    [dispatch, id],
  )

  return useMemo(() => ({ close, id, open }), [close, id, open])
}
